// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contFlujoModal{
    position: relative;
    width: 100%;
    height: 100%;
    display: block;
}
.contflujoload{
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center
}
.bodyContFlujoModal  .contflujoload  .loadSimple circle{
    stroke: var(--main-color);
}

.headContFlujoModal
{
    position: relative;
    width: 100%;
    height: 8%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-color: aliceblue; */
    font-size: var(--font-size-small);
    color: var(--main-color);
    font-weight: bolder;
    z-index:1;
}
.bodyContFlujoModal{
    position: relative;
  width: 100%;
  height: 90%;
  display: block;
  justify-content: center;
  align-items: center;
  overflow: auto;
  padding-top: 10px;
  /* padding-bottom: 10px */
}

.rowLevel{
position: relative;
width: 100%;
height: 25%;
display: flex;
}
.rowSide{
    position: relative;
width: 50%;
height: 100%;
display: flex;
justify-content: center;
align-items: center;
}
.leftSideRow{
    border-right: 2px solid #ec5141;
}
.RightSideRow{
    border-left: 2px solid #ec5141;
}
.contInfoFlujo{
    position: relative;
    width: 80%;
    height: 80%;
    background-color: var(--white-color);
    border: 1px solid var(--border-table-color);
    border-radius: 10px;
    display: block;
    padding: 5px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.RightSideRow .contInfoFlujo{
    border-right: 5px solid var(--second-color);

}
.leftSideRow .contInfoFlujo{
    border-left: 5px solid var(--second-color);

}
.consArrowflujo{
    position: absolute;
    
   
}
 
.arrowLeft{
    left: 0%;
    width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 20px 10px 0;
  border-color: transparent var(--second-color) transparent transparent;
}
.arrowRight{
    right: 0%;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px 0 10px 20px; /* Tamaño del triángulo ajustable */
    border-color: transparent transparent transparent var(--second-color);
}

.contTopInfoFlujo{
    position: relative;
    width: 100%;

    height: 20%;

    display: flex;
    justify-content: center;
}
.contTopLeftFlujo{
    position: relative;
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.contTopRightFlujo{
    position: relative;
    width: 50%;
    height: 100%;
    display: flex;
    
    align-items: center;
}
.contTopRightFlujo.impar{
     justify-content: left;
}
.contTopRightFlujo.par{
     justify-content: right;
}
.txtStatusFlujo{
    position: relative;
    width: 90%;
    height: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-color: green; */
    text-align: center;
    color: rgb(51, 51, 51);
    font-size:  var(--font-size-small);
    font-weight: bold;

}
.txtStatusFlujo.FINALIZADO{
    background-color: green;
}
.txtStatusFlujo.ENPROCESO{
    background-color: rgb(238, 255, 0);
    font-size: var(--font-size-small);
    text-align: center;
}
.txtTimeFlujo{
    color: var(--txt-color);
    font-size: var(--font-size-small);
}
.contBotInfoFlujo{
    position: relative;
    width: 100%;

    height: 80%;

    display: flex;
    justify-content: center;
}
.contBotLeftFlujo{
    position: relative;
    width: 30%;
    height: 100%;
    display: block;
    justify-content: center;
    align-items: center;
}
.contTicketInfo{
    position: relative;
    width: 100%;
    height: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #991607;
    font-size: x-small;
    font-weight: bold;
}
.contBotRightFlujo{
    position: relative;
    width: 90%;
    height: 100%;
    display: block;
    justify-content: right;
    align-items: center;
}
.contMsgFlujo{
    position: relative;
    width: 100%;

    height: 80%;
    color: var(--txt-color);
    font-size: var(--font-size-small);
    display: flex;
    /* justify-content: right; */
    align-items: center;
    /* font-size: small; */
overflow: auto;
}
.contMsgFlujo.par{
    justify-content: right;
}



.contMsgFlujo.impar{
    justify-content: left;
}
.contMsgBotFlujo{

    position: relative;
    width: 100%;

    height: 20%;

    display: flex;
    
    align-items: center;
    font-size: small;
    font-weight: bolder;
    color: var(--txt-color);
    font-size: var(--font-size-small);
}

.contMsgBotFlujo.par{
    justify-content: right;
}
.contMsgBotFlujo.impar{
    justify-content: left;
}`, "",{"version":3,"sources":["webpack://./src/components/modals-monitoreo/styles/FlujoModal.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;AACA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB;AACJ;AACA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iCAAiC;IACjC,iCAAiC;IACjC,wBAAwB;IACxB,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,kBAAkB;EACpB,WAAW;EACX,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;AACA,kBAAkB;AAClB,WAAW;AACX,WAAW;AACX,aAAa;AACb;AACA;IACI,kBAAkB;AACtB,UAAU;AACV,YAAY;AACZ,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,oCAAoC;IACpC,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,wCAAwC;AAC5C;AACA;IACI,2CAA2C;;AAE/C;AACA;IACI,0CAA0C;;AAE9C;AACA;IACI,kBAAkB;;;AAGtB;;AAEA;IACI,QAAQ;IACR,QAAQ;EACV,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,qEAAqE;AACvE;AACA;IACI,SAAS;IACT,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,8BAA8B,EAAE,mCAAmC;IACnE,qEAAqE;AACzE;;AAEA;IACI,kBAAkB;IAClB,WAAW;;IAEX,WAAW;;IAEX,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;;IAEb,mBAAmB;AACvB;AACA;KACK,qBAAqB;AAC1B;AACA;KACK,sBAAsB;AAC3B;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,sBAAsB;IACtB,kCAAkC;IAClC,iBAAiB;;AAErB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,kCAAkC;IAClC,iCAAiC;IACjC,kBAAkB;AACtB;AACA;IACI,uBAAuB;IACvB,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,WAAW;;IAEX,WAAW;;IAEX,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;;IAEX,WAAW;IACX,uBAAuB;IACvB,iCAAiC;IACjC,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;IACnB,sBAAsB;AAC1B,cAAc;AACd;AACA;IACI,sBAAsB;AAC1B;;;;AAIA;IACI,qBAAqB;AACzB;AACA;;IAEI,kBAAkB;IAClB,WAAW;;IAEX,WAAW;;IAEX,aAAa;;IAEb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,qBAAqB;AACzB","sourcesContent":[".contFlujoModal{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n}\r\n.contflujoload{\r\n    width:100%;\r\n    height:100%;\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center\r\n}\r\n.bodyContFlujoModal  .contflujoload  .loadSimple circle{\r\n    stroke: var(--main-color);\r\n}\r\n\r\n.headContFlujoModal\r\n{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 8%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    /* background-color: aliceblue; */\r\n    font-size: var(--font-size-small);\r\n    color: var(--main-color);\r\n    font-weight: bolder;\r\n    z-index:1;\r\n}\r\n.bodyContFlujoModal{\r\n    position: relative;\r\n  width: 100%;\r\n  height: 90%;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  overflow: auto;\r\n  padding-top: 10px;\r\n  /* padding-bottom: 10px */\r\n}\r\n\r\n.rowLevel{\r\nposition: relative;\r\nwidth: 100%;\r\nheight: 25%;\r\ndisplay: flex;\r\n}\r\n.rowSide{\r\n    position: relative;\r\nwidth: 50%;\r\nheight: 100%;\r\ndisplay: flex;\r\njustify-content: center;\r\nalign-items: center;\r\n}\r\n.leftSideRow{\r\n    border-right: 2px solid #ec5141;\r\n}\r\n.RightSideRow{\r\n    border-left: 2px solid #ec5141;\r\n}\r\n.contInfoFlujo{\r\n    position: relative;\r\n    width: 80%;\r\n    height: 80%;\r\n    background-color: var(--white-color);\r\n    border: 1px solid var(--border-table-color);\r\n    border-radius: 10px;\r\n    display: block;\r\n    padding: 5px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n.RightSideRow .contInfoFlujo{\r\n    border-right: 5px solid var(--second-color);\r\n\r\n}\r\n.leftSideRow .contInfoFlujo{\r\n    border-left: 5px solid var(--second-color);\r\n\r\n}\r\n.consArrowflujo{\r\n    position: absolute;\r\n    \r\n   \r\n}\r\n \r\n.arrowLeft{\r\n    left: 0%;\r\n    width: 0;\r\n  height: 0;\r\n  border-style: solid;\r\n  border-width: 10px 20px 10px 0;\r\n  border-color: transparent var(--second-color) transparent transparent;\r\n}\r\n.arrowRight{\r\n    right: 0%;\r\n    width: 0;\r\n    height: 0;\r\n    border-style: solid;\r\n    border-width: 10px 0 10px 20px; /* Tamaño del triángulo ajustable */\r\n    border-color: transparent transparent transparent var(--second-color);\r\n}\r\n\r\n.contTopInfoFlujo{\r\n    position: relative;\r\n    width: 100%;\r\n\r\n    height: 20%;\r\n\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.contTopLeftFlujo{\r\n    position: relative;\r\n    width: 50%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.contTopRightFlujo{\r\n    position: relative;\r\n    width: 50%;\r\n    height: 100%;\r\n    display: flex;\r\n    \r\n    align-items: center;\r\n}\r\n.contTopRightFlujo.impar{\r\n     justify-content: left;\r\n}\r\n.contTopRightFlujo.par{\r\n     justify-content: right;\r\n}\r\n.txtStatusFlujo{\r\n    position: relative;\r\n    width: 90%;\r\n    height: 90%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    /* background-color: green; */\r\n    text-align: center;\r\n    color: rgb(51, 51, 51);\r\n    font-size:  var(--font-size-small);\r\n    font-weight: bold;\r\n\r\n}\r\n.txtStatusFlujo.FINALIZADO{\r\n    background-color: green;\r\n}\r\n.txtStatusFlujo.ENPROCESO{\r\n    background-color: rgb(238, 255, 0);\r\n    font-size: var(--font-size-small);\r\n    text-align: center;\r\n}\r\n.txtTimeFlujo{\r\n    color: var(--txt-color);\r\n    font-size: var(--font-size-small);\r\n}\r\n.contBotInfoFlujo{\r\n    position: relative;\r\n    width: 100%;\r\n\r\n    height: 80%;\r\n\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.contBotLeftFlujo{\r\n    position: relative;\r\n    width: 30%;\r\n    height: 100%;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.contTicketInfo{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 25%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: #991607;\r\n    font-size: x-small;\r\n    font-weight: bold;\r\n}\r\n.contBotRightFlujo{\r\n    position: relative;\r\n    width: 90%;\r\n    height: 100%;\r\n    display: block;\r\n    justify-content: right;\r\n    align-items: center;\r\n}\r\n.contMsgFlujo{\r\n    position: relative;\r\n    width: 100%;\r\n\r\n    height: 80%;\r\n    color: var(--txt-color);\r\n    font-size: var(--font-size-small);\r\n    display: flex;\r\n    /* justify-content: right; */\r\n    align-items: center;\r\n    /* font-size: small; */\r\noverflow: auto;\r\n}\r\n.contMsgFlujo.par{\r\n    justify-content: right;\r\n}\r\n\r\n\r\n\r\n.contMsgFlujo.impar{\r\n    justify-content: left;\r\n}\r\n.contMsgBotFlujo{\r\n\r\n    position: relative;\r\n    width: 100%;\r\n\r\n    height: 20%;\r\n\r\n    display: flex;\r\n    \r\n    align-items: center;\r\n    font-size: small;\r\n    font-weight: bolder;\r\n    color: var(--txt-color);\r\n    font-size: var(--font-size-small);\r\n}\r\n\r\n.contMsgBotFlujo.par{\r\n    justify-content: right;\r\n}\r\n.contMsgBotFlujo.impar{\r\n    justify-content: left;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
